export class ProviderUpdateRequest {
    name: string;
    businessName: string;
    billingEmail: string;
}
